module.exports = __webpack_public_path__ + "static/img/xs1-8.b4e9bff.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-8.png
// module id = 805
// module chunks = 0